var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, Transition, TransitionChild } from '@headlessui/react';
import { classNames } from '@web/utility';
import { Fragment } from 'react';
export var ModalSize;
(function (ModalSize) {
    ModalSize["XS"] = "xs";
    ModalSize["MD"] = "md";
    ModalSize["LG"] = "lg";
    ModalSize["XL"] = "xl";
    ModalSize["XXL"] = "2xl";
    ModalSize["XXXL"] = "3xl";
    ModalSize["XXXXL"] = "4xl";
})(ModalSize || (ModalSize = {}));
var getModalSize = function (size) {
    if (size === ModalSize.XS)
        return 'sm:max-w-xs';
    if (size === ModalSize.MD)
        return 'sm:max-w-md';
    if (size === ModalSize.LG)
        return 'sm:max-w-lg';
    if (size === ModalSize.XL)
        return 'sm:max-w-xl';
    if (size === ModalSize.XXL)
        return 'sm:max-w-2xl';
    if (size === ModalSize.XXXL)
        return 'sm:max-w-3xl';
    if (size === ModalSize.XXXXL)
        return 'sm:max-w-4xl';
    return 'sm:max-w-4xl';
};
var Modal = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, children = _a.children, _b = _a.size, size = _b === void 0 ? ModalSize.XXXXL : _b;
    return (_jsx(Transition, __assign({ show: visible, as: Fragment }, { children: _jsx(Dialog, __assign({ as: "div", "auto-reopen": "true", className: "fixed z-50 inset-0 overflow-y-auto", onClose: onClose }, { children: _jsxs("div", __assign({ className: "flex items-end justify-center min-h-screen pt-20 px-4 pb-40 text-center sm:block sm:p-0" }, { children: [_jsx(Transition, __assign({ show: visible, as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0" }, { children: _jsx("div", { className: "fixed inset-0 z-0 bg-gray-500 bg-opacity-75 transition-opacity" }) })), _jsx("span", __assign({ className: "hidden sm:inline-block sm:align-middle sm:h-screen", "aria-hidden": "true" }, { children: "\u200B" })), _jsx(TransitionChild, __assign({ as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95", enterTo: "opacity-100 translate-y-0 sm:scale-100", leave: "ease-in duration-200", leaveFrom: "opacity-100 translate-y-0 sm:scale-100", leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" }, { children: _jsx("div", __assign({ className: classNames('relative z-10 w-full min-w-0 inline-block align-bottom overflow-x-hidden bg-white rounded-lg p-6 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6', getModalSize(size)) }, { children: children })) }))] })) })) })));
};
export default Modal;
